module.exports = __webpack_public_path__ + "assets/img/weixin.9fbc4ce0.jpg";